import { Translation } from '../types';

export const fi: Translation = {
  common: {
    loading: 'Ladataan...',
    error: 'Virhe',
    cancel: 'Peruuta',
    save: 'Tallenna',
    close: 'Sulje',
    search: 'Hae',
    reload: 'Lataa uudelleen',
    logout: 'Kirjaudu ulos',
    dashboard: 'Työpöytä',
    products: 'Tuotteet',
    settings: 'Asetukset',
    language: 'Kieli',
    businessHours: 'Aukioloajat',
    back: 'Takaisin',
    selectAll: 'Valitse kaikki',
    deselectAll: 'Poista valinnat',
    success: 'Onnistui',
    selected: 'Valittu',
    confirm: 'Vahvista',
    required: 'Pakollinen',
    requiredMarker: '*',
    previous: 'Edellinen',
    next: 'Seuraava',
    allRightsReserved: 'Kaikki oikeudet pidätetään.',
  },
  auth: {
    login: 'Kirjaudu sisään',
    email: 'Sähköpostiosoite',
    password: 'Salasana',
    loginButton: 'Kirjaudu',
    loggingIn: 'Kirjaudutaan...',
    loginSuccess: 'Kirjautuminen onnistui',
    loginError: 'Väärä sähköposti tai salasana',
    invalidEmail: 'Anna kelvollinen sähköpostiosoite',
    requiredFields: 'Täytä kaikki pakolliset kentät',
    demoAccount: 'Demotili:',
    loginDescription: 'Syötä tilisi tiedot kirjautuaksesi',
    welcomeMessage: 'Tervetuloa yritysten tilausjärjestelmään',
    // Registration
    register: 'Rekisteröidy',
    createAccount: 'Luo tili',
    confirmPassword: 'Vahvista salasana',
    passwordRequirements: 'Salasanan tulee olla vähintään 8 merkkiä, sisältäen isoja ja pieniä kirjaimia, numeroita ja erikoismerkkejä',
    passwordsDoNotMatch: 'Salasanat eivät täsmää',
    registrationSuccess: 'Rekisteröinti onnistui',
    registrationDescription: 'Rekisteröidy yritystilille',
    alreadyHaveAccount: 'Onko sinulla jo tili?',
    signIn: 'Kirjaudu sisään',
    dontHaveAccount: 'Eikö sinulla ole tiliä?',
    creatingAccount: 'Luodaan tiliä...',
    registrationNote: 'Huomautus:',
    registrationNotePoints: {
      erpLinking: 'Jos sinulla on yritystili, sähköpostisi linkitetään automaattisesti',
      companyEmail: 'Käytä yrityksen sähköpostiosoitetta rekisteröinnissä',
      contactSupport: 'Ota yhteyttä tukeen, jos tarvitset apua rekisteröinnissä'
    },
    b2bUsers: 'Yritystilin käyttäjät:',
    registeredEmail: 'Rekisteröity sähköpostiosoite',
    registeredPassword: 'Rekisteröinnissä asetettu salasana',
    b2bCustomerRequired: 'Tätä sähköpostiosoitetta ei ole rekisteröity yritysasiakkaaksi. Ota ensin yhteyttä myyntiin luodaksesi liikesuhteen.',
    b2bVerificationError: 'Yritysasiakkaan tilan varmistaminen epäonnistui. Ota yhteyttä tukeen.',
    // Password Reset
    passwordReset: 'Salasanan palautus',
    passwordResetDescription: 'Anna sähköpostiosoitteesi saadaksesi väliaikaisen salasanan',
    getTemporaryPassword: 'Hanki väliaikainen salasana',
    processing: 'Käsitellään...',
    passwordResetComplete: 'Salasana palautettu',
    temporaryPasswordGenerated: 'Väliaikainen salasana luotu',
    temporaryPassword: 'Väliaikainen salasana',
    backToLogin: 'Takaisin kirjautumiseen',
    securityNotice: 'Tietoturvailmoitus:',
    securityNotePoints: {
      keepSecret: 'Älä jaa väliaikaista salasanaa muille',
      changeAfterLogin: 'Vaihda salasana heti kirjautumisen jälkeen',
      expires24Hours: 'Väliaikainen salasana vanhenee 24 tunnin kuluttua'
    },
    resetNote: 'Huomautus:',
    resetNotePoints: {
      registeredEmail: 'Anna rekisteröity sähköpostiosoite',
      passwordDisplayed: 'Väliaikainen salasana näytetään näytöllä',
      changeRequired: 'Salasanan vaihto vaaditaan kirjautumisen jälkeen'
    },
    copied: 'Kopioitu',
    copySuccessMessage: 'Väliaikainen salasana kopioitu leikepöydälle.',
    forgotPassword: 'Unohditko salasanan?',
    // Password Reset Email Request
    sendResetLink: 'Lähetä palautuslinkki',
    sendingEmail: 'Lähetetään sähköpostia...',
    emailSent: 'Sähköposti lähetetty',
    emailSentMessage: 'Jos tämä sähköpostiosoite on järjestelmässämme, saat pian salasanan palautuslinkin.',
    emailNotSent: 'Sähköpostia ei lähetetty',
    emailSentInfo: 'Tarkista sähköpostisi ja roskapostikansio',
    checkEmail: 'Tarkista sähköposti',
    emailInstructions: 'Salasanan palautusohjeet on lähetetty',
    nextSteps: 'Seuraavat vaiheet:',
    nextStepsList: {
      checkInbox: 'Tarkista sähköpostisi ja roskapostikansio',
      clickLink: 'Klikkaa sähköpostin palautuslinkkiä',
      linkExpires: 'Linkki vanhenee 24 tunnin kuluttua',
      contactSupport: 'Ota yhteyttä tukeen, jos et saa sähköpostia',
      rateLimitInfo: 'Rajoitettu 3 pyyntöön tunnissa'
    },
    // Password Reset Completion
    resetLinkSent: 'Palautuslinkki lähetetty',
    resetSuccess: 'Salasana palautettu onnistuneesti',
    passwordUpdated: 'Salasana päivitetty',
    passwordUpdateMessage: 'Salasanasi on päivitetty onnistuneesti. Voit nyt kirjautua uudella salasanallasi.',
    loginWithNewPassword: 'Kirjaudu uudella salasanalla',
    // Reset Token Page
    resetToken: 'Palauta salasana',
    invalidToken: 'Virheellinen palautustunnus',
    expiredToken: 'Palautustunnus on vanhentunut',
    tokenValid: 'Palautustunnus on kelvollinen',
    newPassword: 'Uusi salasana',
    confirmNewPassword: 'Vahvista uusi salasana',
    updatePassword: 'Päivitä salasana',
    updatingPassword: 'Päivitetään salasanaa...',
    passwordMismatch: 'Salasanat eivät täsmää',
    resetInstructions: 'Syötä uusi salasanasi suorittaaksesi palautuksen loppuun',
  },
  accountInfo: {
    title: 'Tilin tiedot',
    loading: 'Ladataan tilin tietoja...',
    error: 'Virhe',
    errorMessage: 'Tilin tietojen hakeminen epäonnistui',
    back: 'Takaisin',
    basicInfo: 'Perustiedot',
    name: 'Nimi',
    email: 'Sähköpostiosoite',
    contactId: 'Knitido-asiakastunnus',
    contactNumber: 'Yhteyshenkilön numero',
    noInfo: 'Ei tietoja',
    companyInfo: 'Yritystiedot',
    company: 'Yrityksen nimi',
    position: 'Asema',
    vatId: 'Y-tunnus',
    billingAddress: 'Laskutusosoite',
    deliveryAddress: 'Toimitusosoite',
    addressInfo: 'Osoitetiedot',
    billingDescription: 'Laskujen ja sopimusasiakirjojen osoite',
    deliveryDescription: 'Tuotteiden vakiotoimitusosoite',
    sameAsBilling: '※ Sama kuin laskutusosoite',
    sameAsDelivery: '※ Sama kuin toimitusosoite',
    companyName: 'Yrityksen nimi',
    contactPerson: 'Yhteyshenkilö',
    address: 'Osoite',
    phoneNumber: 'Puhelinnumero',
    billingUsage: 'Käytetään laskujen, sopimusten ja muiden tärkeiden asiakirjojen osoitteena',
    deliveryUsage: 'Käytetään tilattujen tuotteiden vakiotoimitusossitteena',
    alsoUsedForDelivery: 'Käytetään myös toimitukseen',
    accountType: 'Tilin tyyppi',
    addressId: 'Osoitetunnus',
    // Address editing functionality
    edit: 'Muokkaa',
    editDeliveryAddress: 'Muokkaa toimitusosoitetta',
    editDeliveryDescription: 'Päivitä toimitusosoitetietosi',
    newDeliveryAddress: 'Lisää uusi toimitusosoite',
    newDeliveryDescription: 'Syötä uuden toimitusosoitteesi tiedot',
    noDeliveryAddress: 'Toimitusosoitetta ei ole määritetty',
    success: 'Onnistui',
    addressUpdated: 'Toimitusosoite päivitetty onnistuneesti',
    updateError: 'Toimitusosoitteen päivittäminen epäonnistui',
    requiredFields: 'Täytä kaikki pakolliset kentät',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    streetAddress: 'Katuosoite',
    streetAddress2: 'Katuosoite 2',
    city: 'Kaupunki',
    country: 'Maa',
    selectCountry: 'Valitse maa...',
    searchCountry: 'Etsi maa...',
    noCountryFound: 'Maata ei löytynyt.',
    postalCode: 'Postinumero',
    companyNamePlaceholder: 'Anna yrityksen nimi',
    firstNamePlaceholder: 'Etunimi',
    lastNamePlaceholder: 'Sukunimi',
    streetAddressPlaceholder: 'Anna katuosoite',
    streetAddress2Placeholder: 'Huoneisto, toimisto jne.',
    cityPlaceholder: 'Anna kaupunki',
    postalCodePlaceholder: 'Anna postinumero',
    billingNotEditable: 'Laskutusosoitetta ei voi muokata.',
    billingContactSupport: 'Ota yhteyttä tukeen muutoksia varten.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} toimitusosoitetta',
    noDeliveryAddresses: 'Ei rekisteröityjä toimitusosoitteita',
    defaultAddress: 'Oletusarvo',
    selectDeliveryAddress: 'Valitse toimitusosoite',
    addNewAddress: 'Lisää uusi osoite',
    editAddress: 'Muokkaa osoitetta',
    deleteAddress: 'Poista osoite',
    confirmDelete: 'Vahvista poisto',
    confirmDeleteMessage: 'Haluatko varmasti poistaa tämän osoitteen? Tätä toimintoa ei voi peruuttaa.',
    addressAddedSuccess: 'Toimitusosoite lisätty',
    addressDeletedSuccess: 'Toimitusosoite poistettu',
    deleteError: 'Toimitusosoitteen poistaminen epäonnistui',
    saving: 'Tallennetaan...',
    cancel: 'Peruuta',
    saveChanges: 'Tallenna muutokset',
    selectedDeliveryAddress: 'Valittu toimitusosoite',
  },
  dashboard: {
    title: 'Yrityskumppani',
    subtitle: 'Tuotteiden tilausjärjestelmä',
    welcome: 'Tervetuloa,',
    welcomeMessage: 'Tervetuloa yrityskumppaneiden tilausjärjestelmään. Täältä voit tilata tuotteita.',
    productCatalog: 'Tuotekatalogi',
    productCatalogDesc: 'Selaa ja tilaa saatavilla olevia tuotteita',
    viewProducts: 'Näytä tuotteet',
    orderHistory: 'Tilaushistoria',
    orderHistoryDesc: 'Tarkastele aiempia tilauksia',
    accountSettings: 'Tilin asetukset',
    accountSettingsDesc: 'Hallitse tilin tietoja',
    comingSoon: 'Tulossa pian',
    infoTitle: 'Käytöstä',
    orderingInfo: 'Tuotteiden tilaaminen',
    orderingDesc: 'Valitse tuotteita katalogista ja määritä koko ja väri. Varastotiedot ovat käytettävissä reaaliajassa.',
    supportInfo: 'Tuki',
    supportDesc: 'Jos sinulla on kysyttävää, ota meihin yhteyttä.',
    viewOrderHistory: 'Näytä tilaushistoria',
    viewOrders: 'Näytä tilaukset',
    accountInfo: 'Tilin tiedot',
    accountInfoDesc: 'Tarkastele tilisi tietoja',
    viewDetails: 'Näytä tiedot',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Maanantai-perjantai 9:00 - 15:00 CET',
    bulkImportDesc: 'Tuo tilauksia Excel/CSV-tiedostoista',
    importOrders: 'Tuo tilauksia',
  },
  products: {
    title: 'Tuoteluettelo',
    subtitle: 'Yrityskumppani',
    searchPlaceholder: 'Hae tuotteen nimellä tai SKU-koodilla...',
    productId: 'Tuotetunnus',
    addToCart: 'Lisää ostoskoriin',
    selectVariation: 'Valitse variaatio',
    price: 'Hinta',
    priceNetNotice: 'Kaikki hinnat ovat verottomia',
    stock: 'Varasto',
    color: 'Väri',
    newProducts: 'Uudet Tuotteet',
    newProductBadge: 'UUSI',
    size: 'Koko',
    quantity: 'Määrä',
    total: 'Yhteensä',
    cart: 'Ostoskori',
    checkout: 'Kassalle',
    csvMode: 'CSV-pikatila',
    csvInfo: 'Tuotetiedot haettu CSV-tiedostosta',
    csvUploadDate: 'CSV-latauksen päivämäärä:',
    stockNote: '※ Varastotiedot haetaan tuotevariaatioita valittaessa',
    noProducts: 'Tuotteita ei löytynyt',
    noProductsDesc: 'Muuta hakuehtoja tai lataa CSV-tiedosto nopeuttaaksesi toimintaa.',
    retry: 'Yritä uudelleen',
    pagination: 'kpl',
    variations: 'variaatiot',
    stockFetchError: 'Varastohaun virhe',
    stockFetchFailed: 'Varastohaku epäonnistui',
    stockFetchFailedDesc: 'Varastotietojen hakeminen epäonnistui. CSV-varastot näytetään.',
    stockFetched: 'Varastotiedot haettu',
    totalStock: 'Kokonaisvarasto',
    noStockAll: 'Kaikki variaatiot loppu varastosta',
    noStockData: 'Varastotietoja ei palautettu',
    stockFetchErrorDesc: 'Varastotietoja haettaessa tapahtui virhe',
    selectionError: 'Valintavirhe',
    enterQuantity: 'Anna määrä',
    addedToCart: 'Lisätty ostoskoriin',
    typesAdded: ' tuotetyyppiä lisätty',
    addToCartError: 'Virhe ostoskoriin lisättäessä',
    addToCartErrorDesc: 'Yritä uudelleen',
    loadingStock: 'Ladataan varastotietoja',
    csvDataInfo: 'Näytetään CSV-tiedot (ei todellisia varastomääriä)',
    invalidDataFormat: 'Virheellinen tuotetietojen muoto',
    loadFailed: 'Tuotetietojen lataaminen epäonnistui',
    csvUploadComplete: 'CSV-lataus valmis',
    csvLoadedDesc: ' tuotetietoa ladattu. Varastotiedot haetaan tuotteita valittaessa.',
    searchTitle: 'Tuotehaku',
    loadingProducts: 'Ladataan tuotetietoja',
    noProductsCsv: 'CSV-tiedoista ei löytynyt tuotteita. Muuta hakuehtoja.',
    paginationDisplay: ' näytetään',
    previous: 'Edellinen',
    next: 'Seuraava',
    selectionSummary: 'Valinnan yhteenveto',
    selectedQuantity: 'Valittu määrä',
    items: ' kpl',
    viewDetails: 'Näytä tiedot',
    productImage: 'Tuotekuva',
    correspondingVariations: 'Vastaavat variaatiot',
    clickToEnlarge: 'Klikkaa suurentaaksesi',
    productIdLabel: 'Tuotetunnus',
    colorLabel: 'Väri',
    filterByCategory: 'Suodata kategorian mukaan',
    allProducts: 'Kaikki tuotteet',
    applyFilters: 'Käytä suodattimia',
    clearFilters: 'Tyhjennä suodattimet',
    filters: 'Suodattimet',
    clearAll: 'Tyhjennä kaikki',
  },
  categories: {
    category_21: 'Varvassukka',
    category_23: 'Luokittelematon',
    category_24: 'Vartalotuotteet',
    category_29: 'B2B-tuotteet',
  },
  productDetail: {
    title: 'Tuotteen tiedot',
    backToProducts: 'Takaisin tuotteisiin',
    productNotFound: 'Tuotetta ei löytynyt',
    productNotFoundDesc: 'Määritettyä tuotetta ei ole tai se on poistettu.',
    loading: 'Ladataan tuotetta...',
    imageLoadError: 'Kuvien lataaminen epäonnistui',
    noImages: 'Kuvia ei saatavilla',
    productDescription: 'Tuotekuvaus',
    colors: 'Värit',
    sizes: 'Koot',
    colorCount: 'värit',
    sizeCount: 'koot',
    variationCount: 'variaatiot',
    selectVariation: 'Valitse variaatiot',
    descriptionLanguageNote: '※ Tuotekuvaukset ovat saatavilla vain englanniksi tai saksaksi',
  },
  colors: {
    schwarz: 'Musta',
    weiß: 'Valkoinen',
    grau: 'Harmaa',
    rot: 'Punainen',
    blau: 'Sininen',
    grün: 'Vihreä',
    gelb: 'Keltainen',
    rosa: 'Vaaleanpunainen',
    lila: 'Violetti',
    braun: 'Ruskea',
    orange: 'Oranssi',
    beige: 'Beige',
    navy: 'Laivastonsininen',
    dunkelblau: 'Tummansininen',
    hellblau: 'Vaaleansininen',
    dunkelgrau: 'Tummanharmaa',
    hellgrau: 'Vaaleanharmaa',
    bordeaux: 'Viininpunainen',
    türkis: 'Turkoosi',
    khaki: 'Khaki',
    mint: 'Minttu',
    violett: 'Violetti',
    anthrazit: 'Antrasiitti',
    blaugrau: 'Siniharmaa',
    burgunderrot: 'Burgundinpunainen',
    elfenbein: 'Norsunluu',
    karminrot: 'Karmiininpunainen',
    neongrün: 'Neonvihreä',
    gelbgrün: 'Keltavihreä',
    pistazie: 'Pistaasi',
    // Englanninkieliset värinimet (käytetään Product ID 237 jne.)
    blue: 'Sininen',
    ivory: 'Norsunluu',
    green: 'Vihreä',
    gold: 'Kulta',
    red: 'Punainen',
  },
  checkout: {
    title: 'Kassa',
    cartReview: 'Tilauksen tarkistus',
    orderSummary: 'Tilauksen yhteenveto',
    shippingInfo: 'Toimitustiedot',
    billingInfo: 'Laskutustiedot',
    orderNotes: 'Tilauksen huomautukset',
    orderNotesPlaceholder: 'Erityistoiveet tai huomautukset...',
    contactPerson: 'Yhteyshenkilö',
    phoneNumber: 'Puhelinnumero',
    email: 'Sähköpostiosoite',
    company: 'Yritys',
    address: 'Osoite',
    city: 'Kaupunki',
    postalCode: 'Postinumero',
    country: 'Maa',
    deliveryDate: 'Toimituspäivä',
    urgentDelivery: 'Pikatoimitus (3-5 arkipäivää)',
    standardDelivery: 'Vakiotoimitus (7-10 arkipäivää)',
    placeOrder: 'Lähetä tilaus',
    backToCart: 'Takaisin tuotevalintaan',
    requiredField: 'Pakollinen kenttä',
    orderTotal: 'Tilauksen summa',
    subtotal: 'Välisumma',
    priceNetNotice: 'Kaikki hinnat ovat verottomia',
    stockReservationNotice: 'Varastovaraus tehdään tilauksen vahvistuksen jälkeen.',
    stockCheckError: 'Varastotarkistuksen virhe',
    stockCheckErrorDesc: 'Varastotarkistuksessa tapahtui virhe. Yritä uudelleen.',
    shipping: 'Toimitus',
    shippingCost: 'Toimituskulut',
    tax: 'Vero',
    orderSuccess: 'Tilaus onnistui',
    orderSuccessMessage: 'Tilauksesi on lähetetty onnistuneesti. Tilausnumero: {orderNumber}',
    orderNumber: 'Tilausnumero',
    thankYou: 'Kiitos tilauksestasi!',
    orderConfirmation: 'Tilauksesi on lähetetty onnistuneesti.',
    orderProcessing: 'Tiimimme tarkastuksen jälkeen lähetämme tilausvahvistuksen sähköpostitse.',
    orderProcessingMessage: 'Tilauksesi on lähetetty onnistuneesti. Tiimimme tarkastuksen jälkeen lähetämme tilausvahvistuksen sähköpostitse.',
    continueShopping: 'Jatka ostoksia',
    emptyCart: 'Ostoskorisi on tyhjä',
    emptyCartMessage: 'Lisää tuotteita ostoskoriin jatkaaksesi',
    stockWarning: 'Varastovaroitus',
    stockWarningDesc: 'Joidenkin tuotteiden varasto ei riitä. Säädä määriä.',
    stockError: 'Varastovirhe',
    stockErrorDesc: 'Osalla tuotteista on riittämätön varasto. Säädä määriä.',
    refreshStock: 'Päivitä varasto',
    stockUpdated: 'Varasto päivitetty',
    stockUpdatedDesc: 'Varasto päivitetty - {changed} tuotetta muuttunut',
    stockCheckDesc: 'Vertailutulokset varaston kanssa näytetään',
    stockOk: 'Varasto OK',
    stockShortage: 'Varastovajaus',
    requestedQty: 'Pyydetty määrä',
    currentStock: 'Nykyinen varasto',
    stockShortageMsg: 'Riittämätön varasto. Säädä määrää.',
    stockIssueWarning: 'Tilausta ei voi vahvistaa varastoongelmien vuoksi.',
    stockDataMissing: 'Varastotietoja haetaan. Odota hetki.',
    outOfStock: 'Loppu varastosta.',
    maxAvailable: 'Maksimi',
    autoRestored: 'Ostoskori palautettu',
    autoRestoredDesc: 'Viime istunnon tuotteet on palautettu',
    maxQuantityReached: 'Maksimi varastomäärä saavutettu.',
    // ERP Contact Search
    contactSearch: 'Asiakaskontaktin haku',
    contactSearchDesc: 'Anna tilaajan sähköpostiosoite hakeaksesi kontaktitiedot',
    emailAddress: 'Sähköpostiosoite',
    searchButton: 'Hae',
    searching: 'Haetaan',
    contactFound: 'Kontakti löydetty',
    contactNotFound: 'Kontaktia ei löytynyt',
    contactId: 'Knitido-asiakastunnus',
    companyName: 'Yritys',
    contactPersonLabel: 'Yhteyshenkilö',
    addressesFound: 'Löydetyt osoitteet',
    addressType: 'Tyyppi',
    addressBilling: 'Laskutusosoite',
    addressDelivery: 'Toimitusosoite',
    vatSourceCompany: 'Yritystiedot',
    vatSourceBilling: 'Laskutus',
    vatSourceDelivery: 'Toimitus',
    addressOther: 'Muu',
    addressDetails: 'Osoite',
    loadingAddresses: 'Ladataan osoitetietoja...',
    addressRetrieved: 'Osoitetiedot haettu',
    addressNotFound: 'Osoitetietoja ei löytynyt',
    addressNotFoundDesc: 'Rekisteröityjä osoitetietoja ei ole. Anna tiedot manuaalisesti.',
    addressError: 'Osoitteen hakuvirhe',
    addressErrorDesc: 'Osoitetietojen hakeminen epäonnistui.',
    contactNotConfirmed: 'Asiakaskontaktia ei vahvistettu',
    contactNotConfirmedDesc: 'Anna sähköpostiosoite ja hae kontakti.',
    searchContact: 'Hae kontakti',
    inputError: 'Syöttövirhe',
    inputErrorDesc: 'Toimitustiedot ovat puutteelliset. Tarkista.',
    processing: 'Käsitellään...',
    erpContactSearch: 'Asiakaskontaktin haku',
    contactSearchError: 'Sähköpostiosoite ei vastaa mitään rekisteröityä kontaktia.',
    // Product Images Toggle
    showProductImages: 'Näytä tuotekuvat',
    showProductImagesDesc: 'Näytä tuotekuvat paremman yleiskuvan saamiseksi (voi hidastaa latausaikaa)',
    // System Registration Info
    systemRegistrationInfo: 'Asiakastietosi',
    editShippingAddress: 'Muokkaa toimitusosoitetta',
    systemRegistrationInfoDesc: 'Rekisteröidyt yritystietosi. Ota yhteyttä edustajaasi, jos laskutusosoitteen tiedot täytyy päivittää.',
    // Order Summary
    regularPrice: 'Normaali tukkuhinta',
    offeredPrice: 'Tarjoushinta',
    discount: 'Alennus',
    b2bCustomer: 'B2B-asiakas',
    pattern: 'Malli',
    specialPriceApplied: 'Erikoishinta käytössä',
    customerClassification: 'Asiakasluokitus',
    paymentCondition: 'Maksuehdot',
    invoice: 'Lasku (NET 30)',
    prepayment: 'Ennakkomaksu',
    paymentMethod: 'Maksutapa',
    invoicePayment: 'Laskumaksu',
    estimatedSubtotal: 'Arvioitu välisumma',
    estimatedTotal: 'Arvioitu yhteissumma',
    orderSummaryDisclaimer: 'Tässä näkyvät hinnat ovat arvioita. Kun saamme tilauksesi, tarkistamme sen ja lähetämme sinulle sitovan tilausvahvistuksen lopullisine hintoineen, toimituskuluineen ja veroineen sähköpostitse.',
    searchError: 'Hakuvirhe',
    searchErrorDesc: 'Kontaktihaun aikana tapahtui virhe.',
    confirmDeleteItem: 'Poista tuote',
    itemDeleted: 'Tuote poistettu',
    confirmDeleteItemDesc: 'Haluatko varmasti poistaa seuraavan tuotteen ostoskorista?',
    deleteConfirm: 'Poista',
    contactNotes: 'Yhteystiedot',
    contactNotesDesc: 'Onko sinulla kysyttävää tai erityistoiveita? Kerro meille (valinnainen)',
    contactNotesLabel: 'Viesti',
    contactNotesPlaceholder: 'esim.: Tuotekysymykset, erityisvaatimukset jne.',
    characters: 'merkkiä',
    contactIdLabel: 'Knitido-asiakastunnus',
    companyLabel: 'Yritys',
    personLabel: 'Yhteyshenkilö',
    emailLabel: 'Sähköposti',
    addressTypeLabel: 'Tyyppi',
    destinationLabel: 'Määränpää',
    // Shipping Form
    shippingTitle: 'Toimitustiedot',
    shippingDesc: 'Anna tuotteiden toimitusosoite',
    companyRequired: 'Yritys *',
    contactPersonRequired: 'Yhteyshenkilö *',
    emailRequired: 'Sähköpostiosoite *',
    phoneRequired: 'Puhelinnumero *',
    addressRequired: 'Osoite 1 *',
    address2: 'Osoite 2 (Rakennus/Huone)',
    postalCodeRequired: 'Postinumero *',
    cityRequired: 'Kaupunki *',
    countryRequired: 'Maa *',
    selectCountry: 'Valitse maa',
    shippingMethodRequired: 'Toimitustapa *',
    selectShippingMethod: 'Valitse toimitustapa',
    urgentDeliveryOption: 'Pikatoimitus (lisämaksut)',
    deliveryNotes: 'Toimitushuomautukset',
    deliveryNotesPlaceholder: 'Anna toimitusaikatoiveet tai muut pyynnöt',
    standardShipping: 'Vakiotoimitus (3-5 arkipäivää)',
    expressShipping: 'Pikatoimitus (1-2 arkipäivää)',
    overnightShipping: 'Yön yli -toimitus',
    germany: 'Saksa',
    austria: 'Itävalta',
    switzerland: 'Sveitsi',
    japan: 'Japani',
    shippingAddressLabel: 'Toimitusosoite',
    changeDeliveryAddress: 'Vaihda toimitusosoite',
    selectDeliveryAddress: 'Valitse toimitusosoite',
    // Shipping Cost Details
    freeShipping: 'Ilmainen toimitus',
    shippingError: 'Virhe',
    shippingZone: 'Toimitusalue',
    remainingForFreeShipping: 'Ilmaiseen toimitukseen {amount}',
    moreForFreeShipping: 'ilmaiseen toimitukseen',
    freeShippingProgress: 'Ilmainen toimitus alkaen',
    andAboveFreeShipping: 'ja ylöspäin ilmainen toimitus',
    freeShippingAchieved: 'Ilmainen toimitus käytössä',
    threshold: 'ja ylöspäin',
    nextShippingTier: 'Seuraava toimitusalennus',
    moreForDiscount: 'lisää',
    shippingSavings: 'toimitussäästöihin',
    orderAmountThreshold: 'ja ylöspäin',
    specialRegionNotice: 'Erikoistoimitusalue käytössä',
    defaultShippingApplied: 'Vakiotoimitushinnat käytössä',
    requestedQuantity: 'Pyydetty määrä',
    availableQuantity: 'Saatavilla oleva määrä',
    orderSubmitError: 'Tilausvirhe',
    orderSubmitErrorDesc: 'Tilauksen lähettäminen epäonnistui',
    upload: {
      title: 'Tuo Excel/CSV-tilaus',
      description: 'Lataa Excel- tai CSV-tiedosto tilauksen tiedoilla',
      dragDropOrClick: 'Vedä ja pudota tiedosto tähän tai klikkaa valitaksesi',
      dropHere: 'Pudota tiedosto tähän',
      supportedFormats: 'Tuetut muodot: Excel (.xlsx, .xls) ja CSV (.csv)',
      maxSize: 'Tiedoston maksimikoko: {size} MB',
      processFile: 'Käsittele tiedosto',
      processing: 'Käsitellään tiedostoa...',
      ready: 'Tiedosto valmis esikatseluun',
      readyDescription: 'Tiedostosi on käsitelty onnistuneesti ja on valmis tarkistettavaksi.',
      preview: 'Näytä esikatselu',
      errors: {
        fileTooLarge: 'Tiedosto on liian suuri. Maksimikoko: {size} MB',
        invalidFileType: 'Virheellinen tiedostotyyppi. Lataa Excel- tai CSV-tiedosto',
        uploadFailed: 'Tiedoston lataaminen epäonnistui',
      },
    },
    // Loading messages
    loadingPage: 'Ladataan sivua...',
    loadingStock: 'Tarkistetaan tuotevarastoja...',
    loadingAccount: 'Ladataan tilin tietoja...',
    loadingError: 'Tapahtui virhe...',
    loadingData: 'Ladataan tietoja',
    // Toast messages
    addressRetrievedTitle: 'Osoitetiedot haettu',
    addressSetAsDelivery: ' osoite asetettu toimituskohteeksi.',
    contactFoundDesc: ' tunnistettiin.'
  },
  orderHistory: {
    title: 'Tilaushistoria',
    searchPlaceholder: 'Hae tilausnumerolla tai SKU-koodilla...',
    noOrders: 'Tilauksia ei löytynyt',
    noOrdersFound: 'Vastaavia tilauksia ei löytynyt',
    startShopping: 'Näytä tuotteet',
    orderItems: 'Tilauksen tuotteet',
    viewDetails: 'Tiedot',
    reorder: 'Tilaa uudelleen',
    orderDate: 'Tilauspäivä',
    orderStatus: 'Tila',
    orderTotal: 'Tilauksen summa',
    // Status translations
    statusPending: 'Odottaa maksua',
    statusProcessing: 'Käsitellään',
    statusConfirmed: 'Vahvistettu',
    statusShipped: 'Lähetetty',
    statusDelivered: 'Toimitettu',
    statusCancelled: 'Peruutettu',
    statusReturned: 'Palautettu',
    statusRefunded: 'Hyvitetty',
    statusWarranty: 'Takuu',
    statusExchanged: 'Vaihdettu',
    statusRepair: 'Korjaus',
    statusUnknown: 'Tuntematon',
    statusIncomplete: 'Keskeneräinen',
    statusWaitingPayment: 'Odottaa maksua',
    statusInPreparation: 'Valmistellaan',
    statusClearedShipping: 'Valmis lähetettäväksi',
    statusBeingShipped: 'Lähetetään',
    statusOutgoingBooked: 'Lähtö varattu',
    statusReturn: 'Palautus',
    // Additional UI elements
    itemCount: 'tuotetta',
    itemCountSingular: 'tuote',
    refreshButton: 'Päivitä',
    errorFetchingOrders: 'Tilaushistorian hakeminen epäonnistui',
    // Payment status features
    paymentStatus: 'Maksun tila',
    markAsPaid: 'Merkitse maksetuksi',
    unmarkAsPaid: 'Poista maksumerkintä',
    paidOn: 'Maksettu',
    paymentMarked: 'Maksettu',
    notPaid: 'Maksamatta',
    paymentMarkedSuccess: 'Onnistuneesti merkitty maksetuksi',
    paymentUnmarkedSuccess: 'Maksumerkintä poistettu',
    paymentUpdateError: 'Maksun tilan päivittäminen epäonnistui',
    // Payment date dialog
    paymentDateTitle: 'Syötä maksutiedot',
    paymentDateDescription: 'Syötä maksutiedot tilaukselle {orderNumber}',
    paymentDateLabel: 'Maksupäivä',
    selectDate: 'Valitse päivämäärä',
    paymentDateHelp: 'Valitse päivämäärä, jolloin pankkisiirto tehtiin',
    paymentMethodLabel: 'Maksutapa',
    bankTransfer: 'Pankkisiirto',
    invoice: 'Lasku',
    otherPayment: 'Muu',
    paymentReferenceLabel: 'Siirron nimi / Viitenumero',
    paymentReferencePlaceholder: 'esim. Matti Meikäläinen, Siirto #12345',
    paymentReferenceHelp: 'Anna tiedot, jotka auttavat täsmäyttämään tiliotteen kanssa',
    notesLabel: 'Huomautukset',
    notesPlaceholder: 'Anna lisätietoja maksusta',
    // Filter options
    filterByPaymentStatus: 'Suodata maksun tilan mukaan',
    allOrders: 'Kaikki tilaukset',
    paidOrders: 'Maksetut',
    unpaidOrders: 'Maksamattomat',
    // Sorting options
    sortBy: 'Lajittele',
    sortByDate: 'Tilauspäivä',
    sortByPaymentDate: 'Maksupäivä',
    sortByAmount: 'Summa',
    sortByStatus: 'Tila',
  },
  orderDetails: {
    title: 'Tilauksen tiedot',
    notFound: 'Tilausta ei löytynyt',
    backToHistory: 'Takaisin tilaushistoriaan',
    orderDate: 'Tilauspäivä',
    orderItems: 'Tilauksen tuotteet',
    deliveryStatus: 'Toimituksen tila',
    estimatedDelivery: 'Arvioitu toimitus',
    deliveredOn: 'Toimitettu',
    downloadInvoice: 'Lataa lasku',
    statusDelivered: 'Toimitettu',
    statusShipped: 'Lähetetty',
    statusConfirmed: 'Vahvistettu',
    statusCancelled: 'Peruutettu',
    errorFetchingDetails: 'Tilauksen tietojen hakeminen epäonnistui',
  },
  company: {
    name: 'Yrityskumppani',
    tagline: 'Yrityskumppanijärjestelmä',
    copyright: '© 2025 Yrityskumppanijärjestelmä. Kaikki oikeudet pidätetään.',
  },
  footer: {
    phone: 'Puhelin',
    email: 'Sähköposti',
    countries: {
      DE: 'Saksa',
      AT: 'Itävalta',
      CH: 'Sveitsi',
      FR: 'Ranska',
      IT: 'Italia',
      ES: 'Espanja',
      NL: 'Alankomaat',
      BE: 'Belgia',
      PL: 'Puola',
      SE: 'Ruotsi',
      NO: 'Norja',
      FI: 'Suomi',
      DK: 'Tanska',
      LT: 'Liettua',
      LV: 'Latvia',
      EE: 'Viro',
    },
  },
  cart: {
    newCart: 'Uusi ostoskori',
    currentCart: 'Nykyinen ostoskori',
    modified: 'muokattu',
    lastSaved: 'Viimeksi tallennettu',
    unsavedChanges: 'tallentamattomat muutokset',
    saveCart: 'Tallenna ostoskori',
    loadCart: 'Lataa ostoskori',
    deleteCart: 'Poista ostoskori',
    startNewCart: 'Aloita uusi ostoskori',
    savedCarts: 'Tallennetut ostoskorit',
    cartSaved: 'Ostoskori tallennettu',
    cartDeleted: 'Ostoskori poistettu',
    confirmDeleteCart: 'Poista ostoskori?\n\nTätä toimintoa ei voi perua.',
    confirmSwitchCart: 'Nykyisessä ostoskorissa on tallentamattomia muutoksia.\n\nToisen ostoskorin lataaminen hävittää nykyiset muutokset.\n\nJatka?',
    confirmSwitchCartTitle: 'Vaihda ostoskori',
    confirmNewCart: 'Nykyisessä ostoskorissa on tallentamattomia muutoksia.\n\nUuden ostoskorin aloittaminen hävittää nykyiset muutokset.\n\nJatka?',
    confirmNewCartTitle: 'Aloita uusi ostoskori',
    confirmClearCart: 'Tyhjennä ostoskori?\n\n{count} tuotetta poistetaan.\n\nTätä toimintoa ei voi perua.',
    confirmClearCartTitle: 'Tyhjennä ostoskori',
    autoSaved: 'Automaattisesti tallennettu',
    itemsWillBeRemoved: 'tuotetta poistetaan',
    changesWillBeLost: 'muutokset menetetään',
    continueQuestion: 'Jatka?',
    cartStatus: 'Ostoskorin tila',
    cartName: 'Ostoskorin nimi',
    cartNamePlaceholder: 'esim.: Kuun lopun tilaus',
    cartNameRequired: 'Anna ostoskorille nimi',
    saveCartDescription: 'Anna nykyiselle ostoskorille nimi ja tallenna se. Voit ladata sen myöhemmin.',
    cancelCart: 'Peruuta ostoskori',
    proceedToCheckout: 'Siirry kassalle',
    emptyCart: 'Ostoskori on tyhjä',
    erpDown: 'Tilausjärjestelmä on pois käytöstä. Yritä uudelleen myöhemmin.',
    erpDegraded: 'Järjestelmä on tällä hetkellä epävakaa. Tilaukset saattavat epäonnistua.',
    erpDownSaveHint: 'Tallenna ostoskorisi ja tilaa, kun järjestelmä on palautunut.',
    erpSaveCart: 'Tallenna ostoskori',
  },
  nav: {
    dashboard: 'Työpöytä',
    products: 'Tuotteet',
    orderHistory: 'Tilaukset',
    account: 'Tilin tiedot',
    bulkImport: 'Massatuonti',
  },
  settings: {
    selectLanguage: 'Valitse kieli',
    languagePreferenceSaved: 'Valintasi tallennetaan tilillesi tulevia käyntejä varten.',
  },
  reorder: {
    allItemsAdded: '{count} tuotetta lisätty ostoskoriin',
    partialSuccess: '{added} tuotetta lisätty. {failed} tuotetta ei voitu lisätä',
    allItemsFailed: 'Tuotteiden lisääminen ostoskoriin epäonnistui',
    error: 'Virhe uudelleentilauksessa',
    itemDiscontinued: '{name} ({color}/{size}) on lopetettu',
    itemOutOfStock: '{name} ({color}/{size}) on loppu varastosta',
    partialStock: '{name} ({color}/{size}) vain {available} saatavilla',
    confirmReorder: 'Vahvista uudelleentilaus',
    confirmReorderMessage: 'Lisää tämän tilauksen tuotteet ostoskoriin?',
    addingToCart: 'Lisätään ostoskoriin...',
    checkingStock: 'Tarkistetaan varastoa...',
    checkoutTitle: 'Tuotteet lisätty ostoskoriin',
    checkoutDescription: '{count} tuotetta lisätty ostoskoriisi. Haluatko siirtyä kassalle?',
  },
  bulkImport: {
    instructions: 'Tilausten tuominen',
    step1: 'Lataa tilausmalli',
    step2: 'Täytä tilauksen tiedot SKU-koodeilla ja määrillä',
    step3: 'Tallenna Excel- (.xlsx) tai CSV-tiedostona',
    step4: 'Lataa tiedosto alla olevalla lomakkeella',
    step5: 'Tarkista ja vahvista tilauksesi',
    downloadTemplate: 'Lataa malli',
    downloadExcelTemplate: 'Lataa Excel-malli',
    downloadCsvTemplate: 'Lataa CSV-malli',
    formatGuide: 'Tiedostomuodon opas',
    requiredColumns: 'Pakolliset sarakkeet',
    skuDescription: 'Tuotteen SKU-koodi',
    quantityDescription: 'Tilausmäärä (positiivinen kokonaisluku)',
    optionalColumns: 'Valinnaiset sarakkeet',
    notesDescription: 'Sisäiset huomautukset (esim. PO-numero, viite) - vain omiin tietoihin',
    formatNote: 'Ensimmäisellä rivillä tulee olla sarakkeiden otsikot. Tiedot alkavat toiselta riviltä.',
    parseSuccess: 'Onnistuneesti käsitelty {count} tuotetta tiedostosta',
    parseError: 'Käsittelyvirhe',
    validationError: 'Tarkistusvirheet',
    validationErrorGuidance: 'Klikkaa "{showPreviewButton}" -painiketta tarkastellaksesi tietoja.',
    warnings: 'Varoitukset',
    itemsParsed: 'Onnistuneesti käsitelty {count} tuotetta:',
    andMore: '...ja {count} muuta tuotetta',
    validationSummary: 'Tarkistuksen yhteenveto',
    duplicateSKUs: 'Löytyi päällekkäisiä SKU-koodeja',
    skuFormat: 'SKU saa sisältää vain kirjaimia, numeroita ja viivoja',
    quantityRange: 'Määrän tulee olla 1-9999',
    maxRows: 'Maksimissaan 1000 riviä',
    rowsSkipped: '{count} riviä ohitettiin virheiden vuoksi',
    previewTitle: 'Tilauksen esikatselu',
    previewDescription: 'Tarkista ja muokkaa tilauksen tietoja ennen jatkamista',
    proceedToCart: 'Lisää ostoskoriin',
    // File parsing messages
    fileEmpty: 'Tiedosto on tyhjä tai ei sisällä tietoja',
    fileTooManyRows: 'Tiedosto sisältää liikaa rivejä ({current}). Maksimi: {max}',
    invalidRowFormat: 'Virheellinen riviformaatti',
    missingColumns: 'Pakolliset sarakkeet puuttuvat (SKU ja Määrä)',
    missingSku: 'SKU puuttuu',
    invalidSkuFormat: 'Virheellinen SKU-muoto: "{sku}" (tulee vastata mallia: {pattern})',
    skuTooLong: 'SKU liian pitkä: "{sku}" (maksimi 50 merkkiä)',
    invalidQuantity: 'Virheellinen määrä: "{quantity}" ei ole numero',
    quantityTooLow: 'Määrä liian pieni: {quantity} (minimi: {min})',
    quantityTooHigh: 'Määrä liian suuri: {quantity} (maksimi: {max})',
    notesRequired: 'Huomautuskenttä vaaditaan',
    noValidData: 'Kelvollisia tietoja ei löytynyt. Tarkista tiedostomuoto.',
    row: 'Rivi {row}: {errors}',
    rowErrors: '...ja {count} muuta virhettä',
    duplicateSkuInRows: 'Päällekkäinen SKU "{sku}" löydetty riveiltä: {rows}',
    quantityExceedsMax: 'Rivi {row}: Määrä {quantity} ylittää sallitun maksimin ({max})',
    quantityBelowMin: 'Rivi {row}: Määrä {quantity} alittaa vaaditun minimin ({min})',
    // Validation messages
    unsupportedFileFormat: 'Tiedostomuotoa ei tueta. Lataa CSV- tai Excel-tiedosto.',
    csvParsingErrors: 'CSV-käsittelyssä tapahtui virheitä',
    failedToParseFile: 'Tiedoston käsittely epäonnistui',
    failedToParseExcel: 'Excel-tiedoston käsittely epäonnistui',
    failedToReadFile: 'Tiedoston lukeminen epäonnistui',
    unknownError: 'Tuntematon virhe',
    totalRows: 'Rivejä yhteensä',
    valid: 'Kelvollisia',
    invalid: 'Virheellisiä',
    skipped: 'Ohitettuja',
    // SKU validation
    skuValidationError: 'SKU-tarkistusvirhe',
    skuValidationFailed: 'SKU-koodien tarkistus epäonnistui. Voit silti jatkaa, mutta jotkut tuotteet eivät ehkä ole saatavilla.',
    skuNotFound: 'SKU-koodia ei löydy tietokannasta',
    skusNotFound: '{count} SKU-koodia ei löydy tietokannasta',
    itemsHaveInsufficientStock: '{count} tuotteella riittämätön varasto',
    validatingSKUs: 'Tarkistetaan tuotteita...',
    unvalidatedChanges: 'Sinulla on tarkistamattomia muutoksia. Tarkista ennen ostoskoriin lisäämistä.',
    revalidate: 'Tarkista uudelleen',
    validating: 'Tarkistetaan...',
    validationSuccess: 'Kaikki tuotteet kelvollisia',
    validationComplete: 'Tarkistus valmis',
    validationResultSummary: '{errors} virhettä, {warnings} varoitusta löydetty',
    // Table headers
    actions: 'Toiminnot',
    notes: 'Huomautukset',
    // Status filter
    all: 'Kaikki',
    hasErrors: 'Sisältää virheitä',
    // Selection summary
    selected: 'valittu',
    errors: 'virheet',
    // Pagination
    page: 'Sivu {current}/{total}',
    previous: 'Edellinen',
    next: 'Seuraava',
    noResults: 'Ei tuloksia.',
    // Cart integration
    noValidItems: 'Ei kelvollisia tuotteita',
    allItemsHaveErrors: 'Kaikissa tuotteissa on tarkistusvirheitä. Korjaa ne ennen jatkamista.',
    dataLoadingError: 'Tietojen latausvirhe',
    failedToLoadProductData: 'Tuotetietojen lataaminen epäonnistui. Yritä uudelleen.',
    itemsAddedToCart: '{count} tuotetta lisätty ostoskoriin',
    itemsAddedMessage: 'Lisätty {count} tuotetta ostoskoriin',
    someSkusNotFound: '{count} SKU-koodia ei löytynyt.',
    noItemsAdded: 'Tuotteita ei lisätty',
    couldNotFindProducts: 'SKU-koodeja vastaavia tuotteita ei löytynyt.',
    errorAddingToCart: 'Virhe',
    failedToAddToCart: 'Tuotteiden lisääminen ostoskoriin epäonnistui. Yritä uudelleen.',
    addingToCart: 'Lisätään ostoskoriin...',
    // File info
    fileSelected: '{name} valittu käsittelyyn',
    fileSize: '{size} tavua',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Mallin lataus',
    templateWillBeImplemented: 'Mallin lataus toteutetaan vaiheessa 7',
    // Additional validation
    validationFailed: 'Tarkistus epäonnistui',
    // Template download
    templateDownloaded: 'Malli ladattu onnistuneesti',
    templateDownloadError: 'Mallin lataaminen epäonnistui',
    // Template content
    sheetName: 'Massatilaus',
    instructionsSheetName: 'Ohjeet',
    columnDescriptions: 'Sarakkeiden kuvaukset:',
    columnHeader: 'Sarake',
    columnRequired: 'Pakollinen',
    columnOptional: 'Valinnainen',
    columnDescription: 'Kuvaus',
    templateNotes: 'Huomautukset:',
    templateNote1: 'Ensimmäisellä rivillä tulee olla sarakkeiden otsikot täsmälleen kuten näytetty',
    templateNote2: 'Tiedot alkavat riviltä 2',
    templateNote3: 'SKU-koodin tulee vastata järjestelmässä olevia tuotekoodeja',
    templateNote4: 'Määrän tulee olla positiivinen kokonaisluku välillä 1-9999',
    templateNote5: 'Maksimissaan 1000 riviä per tiedosto',
    templateNote6: 'Tallenna .xlsx- tai .csv-muodossa',
    stockAvailabilityWarning: 'Todellinen varastosaatavuus tarkistetaan seuraavalla kassasivulla.',
    outOfStock: 'Loppu varastosta',
    insufficientStock: 'Riittämätön varasto: {available} saatavilla, {requested} pyydetty',
  },
  orderExport: {
    export: 'Vie tilaus',
    exportOrder: 'Vie tilauksen tiedot',
    exportAsCSV: 'Vie CSV-muodossa',
    exportAsExcel: 'Vie Excel-muodossa',
    exportForReorder: 'Vie massatuontia varten',
    detailed: 'Täydet tiedot',
    simpleFormat: 'Tuontimuoto',
  },
};